export default String.raw`
{% assign product = product-presentation.Product -%}
{% assign currency = customer.CurrencyExt.Symbol -%}

{% for unit in product.Units -%}
    {% if unit.Default == true or unit.Id == null -%}
        {% assign unitDimensions = unit.Dimensions-%}
        {% assign unitId = unit.Id -%}
        {% assign unitRatio = unit.Ratio -%}
        {% assign unitName = unit.Name -%}
        {% assign unitMultiplicity = unit.Multiplicity -%}
        {% assign defaultUnit = unit.Default -%}
	{% endif -%}
{% endfor -%}

{% assign tableView = false -%}

<dialog class="dialog set-amount-popup set-amount-popup-js" data-id="{{ product.Id }}">
    <div class="set-amount-popup__header">
        <div class="set-amount-popup__header-title">
            <svg>
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#exclamation-circle-{{settings.iconStyle}}"></use>
            </svg>
            <div class="set-amount-popup__header-title-text">
                <h3>{{ translations.ProductWasNotAdded }}</h3>
                <p>{{ translations.AddMoreProducts }} <span class="message-amount-js"></span></p>
            </div>
        </div>
        <form method="dialog">
			<button class="dialog__close close-js mmq-close-js" aria-label="{{ translations.Close }}">
				<svg aria-hidden="true" height="24" width="24">
					<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
				</svg>
			</button>
		</form>
    </div>
    <div class="set-amount-popup__content form-js">
        <div class="set-amount-popup__content-left">
            <div class="set-amount-popup__content-left-img">
                {% if product.Image.Id > 0 and product.Image.Link != null -%}
                    <img src="img/{{ product.Image.Id }}/{{ product.Image.Link }}" alt="{{ product.Name }}">
                {% elsif product.Image.ExternalUrl != null -%}
                    <img src="{{ product.Image.ExternalUrl }}" alt="{{ product.Name }}">
                {% else -%}
                    <img src="css/img/img-placeholder.jpg" alt="{{ product.Name }}">
                {% endif -%}
            </div>
            <div class="set-amount-popup__content-left-info">
                <p class="set-amount-popup__content-left-info-title">
                    {{ product.NameNoHtml }}
                </p>
                <p class="set-amount-popup__content-left-info-price">
                    {{ product.Price | ToPrice }} {{currency}}
                    {% if customer.Cart.SubtotalPrices -%}
                        <span>{{translations.Netto | Downcase}}</span>
                    {% else -%}
                        <span>{{translations.Brutto | Downcase}}</span>
                    {% endif -%}
                </p>
            </div>
        </div>
        <div class="set-amount-popup__content-text">
            <p class="set-amount-popup__content-text-title">
                {{ product.NameNoHtml }}
            </p>
            <div class="set-amount-popup__content-text-numbers">
                <div class="set-amount-popup__content-text-numbers-amount">
                    <p class="set-amount-popup__content-text-numbers-amount-price">
                        {{ product.Price | ToPrice }} {{currency}}
                        {% if customer.Cart.SubtotalPrices -%}
                            <span>{{translations.Netto | Downcase}}</span>
                        {% else -%}
                            <span>{{translations.Brutto | Downcase}}</span>
                        {% endif -%}
                    </p>
                    <div class="set-amount-popup__content-text-numbers-amount-stepper">
                        {% include 'partials/product/amount-stepper.html' with product -%} <span>{{ unitName }}</span>
                    </div>
                </div>
                <div class="set-amount-popup__content-text-numbers-sum">
                    <p>{{ translations.SumPrice }}: <span class="set-amount-sum-js"></span><span> {{currency}}</span></p>
                </div>
            </div>
        </div>
    </div>
    <div class="set-amount-popup__buttons form-js">
        <form method="dialog">
            <button class="pure-button close-js" style="gap: 10px;">
                <svg class="pure-button__icon">
                    <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#chevron-left-{{settings.iconStyle}}"></use>
                </svg>
                <span class="pure-button__text">{{ translations.BackToShopping }}</span>
            </button>
        </form>

        <input type="hidden" name="__action" value="Cart/Add" >
        <input type="hidden" name="productId" value="{{product.Id}}">
        <input type="hidden" name="quantity" value="{% if product.BasicUnitMultiplicity > 0-%}{{ product.BasicUnitMultiplicity }}{% else -%}1{% endif -%}">
        <button class="primary-action-button add-proper-amount-js close-js add-to-cart-update-client-area-js" disabled>
            <span class="primary-action-button__text">{{ translations.AddToCart }}</span>
            <svg class="primary-action-button__icon">
                <use href="css/img/fontawesome-icons.svg?v={{lqTS}}#shopping-cart-{{settings.iconStyle}}"></use>
            </svg>
        </button>
    </div>
</dialog>
`